<template>
  <span id="update-all-shuttle-file" v-if="isVisible()">
    <el-button
      id="btn-update-all-shuttle-file"
      type="success"
      plain
      @click="dialogVisible = true"
      size="mini"
    >{{ $t('routing.shuttleFile.updateAllShuttleFile') }}
    </el-button>
    <el-dialog
      id="dialog-update-all-shuttle-file"
      :close-on-click-modal="false"
      v-on:open="handleOpen"
      :title="$t('routing.shuttleFile.updateAllShuttleFile')"
      :visible.sync="dialogVisible"
      width="65%"
      class="dialog-with-cols"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :span="12" class="form-vertical-item">
            <el-form-item :label="$t('routing.shuttleFile.outboundWarehouse')" class="inline-input" prop="outboundWarehouseId">
              <outbound-warehouse-select :value.sync="form.outboundWarehouseId" :includeOptionAll="false" ref="outbound-warehouse"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="form-vertical-item">
            <el-form-item :label="$t('routing.shuttleFile.outboundDate')" prop="outboundDate" class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="form.outboundDate"
                format="MM/dd/yyyy"
                clearable
                type="date"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button type="primary" id="form-save-button" @click="submitForm()" size="mini">{{ $t('common.updateAll') }}</el-button>
        <el-button id="form-refresh-button" @click="resetForm()" size="mini">{{ $t('routing.shuttleFile.clear') }}</el-button>
    </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import OutboundWarehouseSelect from '../../components/OutboundWarehouseSelect';

export default {
  name: 'AddShuttleFile',
  components: { OutboundWarehouseSelect },
  computed: {
    ...mapGetters([
      'shuttleFile',
      'user'
    ]),
    daysOptions() {
      return constants.DAYS_OPTIONS.filter(option => option.value != null);
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        outboundDate: null,
        outboundWarehouseId: null
      },
      actualFilters: {
        receivingWarehouseId: null,
        receivingDate: null,
        consigneeAccountId: null,
        outboundWarehouseId: null,
        shuttle: null,
        stateId: null,
        city: null
      },
      formRules: {
        outboundWarehouseId: [
          { required: true, message: this.$t('routing.shuttleFile.errors.outboundWarehouseRequired'), trigger: 'blur' }
        ],
        outboundDate: [
          { required: true, message: this.$t('routing.shuttleFile.errors.outboundDateRequired'), trigger: 'blur' }
        ]
      },
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      this.resetForm();
      done();
    },
    async confirmationMessage() {
      let message = this.$t('routing.shuttleFile.confirmUpdateAll').replace('[unitsInGrid]', this.shuttleFile.total);
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.$store
          .dispatch('shuttleFile/getUnitsToUpdateAllCountSummary', this.actualFilters);
        if (response && response.data) {
          if (response.data.pending > 0) {
            message = message.concat(this.$t('routing.shuttleFile.pendingUnitsConfirmation').replace('[unitsPending]', response.data.pending));
            if (response.data.loaded > 0) {
              message = message.concat(this.$t('routing.shuttleFile.loadedUnitsConfirmation').replace('[unitsLoaded]', response.data.loaded));
            }
            message = message.concat(this.$t('routing.shuttleFile.continueConfirmation'));
          } else if (response.data.shuttled !== 0 || response.data.loaded !== 0) {
            message = message.concat(this.$t('routing.shuttleFile.noUpdatedUnitsConfirmation'));
          }
        }
      } finally {
        loading.close();
      }

      return message;
    },
    submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            Message.closeAll();
            const confirm = await this.$confirm(await this.confirmationMessage(), { dangerouslyUseHTMLString: true, confirmButtonText: this.$t('common.save') }).catch(() => {});
            if (confirm) {
              const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
              this.$store
                .dispatch('shuttleFile/updateAll', {
                  outboundDate: this.form.outboundDate,
                  outboundWarehouseId: this.form.outboundWarehouseId,
                  actualFilters: this.actualFilters
                })
                .then((response) => {
                  loading.close();
                  this.$message.success(response.message);
                  this.resetForm();
                  this.$store.dispatch('shuttleFile/search', {});
                  this.dialogVisible = false;
                  resolve(response);
                })
                .catch(() => {});
            }
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.outboundDate = null;
      this.form.outboundWarehouseId = null;
      this.$refs['outbound-warehouse'].setSelectedWarehouse(this.form.outboundWarehouseId);
      this.actualFilters.receivingWarehouseId = this.user.warehouseId;
      this.actualFilters.receivingDate = this.shuttleFile.actualFilters.receivingDate;
      this.actualFilters.consigneeAccountId = this.shuttleFile.actualFilters.consigneeAccountId;
      this.actualFilters.outboundWarehouseId = this.shuttleFile.actualFilters.outboundWarehouseId;
      this.actualFilters.shuttle = this.shuttleFile.actualFilters.shuttle;
      this.actualFilters.stateId = this.shuttleFile.actualFilters.stateId;
      this.actualFilters.city = this.shuttleFile.actualFilters.city;
    },
    isVisible() {
      const hasShuttleFile = this.shuttleFile.list && this.shuttleFile.list.length > 0;
      const hasUpdateAllShuttleFilePermission = this.$can(this.permissions.ROUTING.UPDATE_ALL_SHUTTLE_FILE);
      return hasShuttleFile && hasUpdateAllShuttleFilePermission;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
button#btn-update-all-shuttle-file {
  margin-right: 10px;
}

#update-all-shuttle-file .el-select, .el-date-editor {
  width: 100%;
}
</style>
